import { UseCasesMenu } from "./UseCasesMenu";
import { YearEndStrip } from "./YearEndStrip";
import { useSiteHeaderHeight } from "./useSiteHeaderHeight";

/** Fixed site header: the seasonal strip stacked above the nav. */
export const LandingNav = () => {
  const headerRef = useSiteHeaderHeight<HTMLElement>();

  return (
    <header ref={headerRef} className="fixed top-0 inset-x-0 z-50">
      <YearEndStrip formId="get-started" />
      <nav className="h-16 px-6 lg:px-12 flex items-center justify-between bg-fwd-white/95 backdrop-blur-sm border-b border-fwd-ink/10">
        <div className="font-display text-lg tracking-tight whitespace-nowrap shrink-0">
          FORWARD{" "}
          <span className="text-fwd-mid text-xs font-sans font-normal ml-1 hidden sm:inline">
            by Juice Analytics
          </span>
        </div>
        <div className="flex items-center gap-4 sm:gap-6">
          <UseCasesMenu triggerClassName="text-fwd-navy/60 hover:text-fwd-navy" />
          <a
            href="#get-started"
            className="bg-fwd-red text-white text-[0.65rem] sm:text-xs font-semibold tracking-widest uppercase whitespace-nowrap px-4 sm:px-5 py-2 sm:py-2.5 rounded hover:opacity-90 transition-opacity"
          >
            Get free mockup
          </a>
        </div>
      </nav>
    </header>
  );
};
